
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/type/[type]",
      function () {
        return require("private-next-pages/templates/type/[type].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates/type/[type]"])
      });
    }
  